import { AbstractControl, ValidationErrors } from '@angular/forms';

export const SOCIAL_SECURITY_NUMBER_LENGTH = 15;

export function normalizeSocialSecurityNumber(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  return `${value}`.replace(/[^0-9a-zA-Z]/g, '').toUpperCase();
}

export class FormValidators {
  static socialSecurityNumber(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (control.value === null || control.value === undefined) {
      return null;
    }
    const normalized = normalizeSocialSecurityNumber(control.value);
    if (`${control.value}` === '') {
      return null;
    }
    if (normalized.length === SOCIAL_SECURITY_NUMBER_LENGTH) {
      return null;
    }
    return {
      custom: `Le numéro de sécurité sociale doit comporter ${SOCIAL_SECURITY_NUMBER_LENGTH} caractères (13 chiffres + 2 chiffres de clé), ${normalized.length} saisi${normalized.length > 1 ? 's' : ''}.`,
    };
  }

  static strictlyPositiveAmount(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (control.value === null || control.value === undefined) {
      return null;
    }
    if (`${control.value}` === '') {
      return null;
    }
    const amount = Number(
      `${control.value}`.replace(/\s/g, '').replace(',', '.'),
    );
    if (Number.isNaN(amount) || amount <= 0) {
      return { custom: 'Saisissez un montant supérieur à 0' };
    }
    return null;
  }

  static dateNotInFuture(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const inputDate = new Date(control.value);
    const today = new Date();
    today.setHours(23, 59, 59, 999);

    if (inputDate > today) {
      return { notInFutureDate: true };
    }
    return null;
  }

  static dateTodayOrInFuture(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const inputDate = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate < today) {
      return { todayOrInFutureDate: true };
    }
    return null;
  }
}
